<template>
  <div id="root">
    <!-- <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content bg-purple">
          <h1>{{ title }}</h1>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content" v-if="!error">
          <el-button type="primary" @click.native="modals.newBSP = true">
            New <i class="el-icon-plus el-icon--right" />
          </el-button>
        </div>
      </el-col>
    </el-row> -->
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content make-space-between">
          <h1 style="margin: 0;">
            {{ title }}
          </h1>
        </div>
      </el-col>
      <el-col :span="2" class="center">
        <div class="grid-content" v-if="!error">
          <p-button
            type="default"
            size="lg"
            icon
            round
            @click.native="modals.newBSP = true"
          >
            <i class="nc-icon nc-simple-add" />
          </p-button>
        </div>
      </el-col>
    </el-row>
    <h5 v-if="loading" style="text-align:center">
      Loading...
    </h5>
    <r-paginated-search-table
      v-if="!error"
      :data="plans"
      :parent-namespace="namespace"
      @updateTable="getPlans"
    >
      <el-table-column
        prop="title"
        label="Title"
      />
      <el-table-column
        prop="created_at"
        label="Created At"
      />
      <el-table-column
        label="Actions"
        width="150"
      >
        <template slot-scope="scope">
          <el-dropdown
            split-button
            type="primary"
            size="small"
            @command="handleDropdownCommand($event, scope.$index)"
            @click="handleEdit(scope.$index)"
          >
            <i class="el-icon-edit el-icon--right" /> Edit
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-document" command="printable" :disabled="true">
                Printable version
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-download" command="pdf" :disabled="true">
                Download PDF
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-mobile" command="mobile" :disabled="true">
                Mobile Friendly Version
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-delete" command="delete">
                Delete
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </r-paginated-search-table>
    <h3 v-else>
      {{ error }}
    </h3>
    <r-new-bsp-modal
      :show="modals.newBSP"
      @close="modals.newBSP = false"
      @save="addNewBibleStudyPlan"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import { mapState, mapActions, vuex } from 'vuex';
import VueMoment from 'vue-moment';
import NewBibleStudyPlanModal from '../../components/BibleStudyPlans/NewBibleStudyPlanModal';
import PaginatedSearchTable from '../../components/Shared/PaginatedSearchTable';
import BibleStudyPlanStoreModule from '../../store/modules/BibleStudyPlans/index';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const BibleStudyPlansRepository = RepositoryFactory.get('bibleStudyPlans');
require('vue-moment');

const data = 'Bible Study Plans';

function formatDate(dateString) {
    const date = new Date(dateString);
    return `${date.getMonth()}-${date.getDay()}-${date.getFullYear()}`;
}

export default {
    // inject: ['BibleStudyPlansRepository'],
    components: {
        [NewBibleStudyPlanModal.name]: NewBibleStudyPlanModal,
        [PaginatedSearchTable.name]: PaginatedSearchTable,
    },
    data() {
        return {
            title: 'Bible Study Plans',
            modals: {
                newBSP: false
            },
            namespace: 'BibleStudyPlans',
            loading: false
        };
    },
    computed: {
        ...mapState({
            rawPlans: (state) => state.BibleStudyPlans.plans,
            error: (state) => state.BibleStudyPlans.error,
        }),
        plans() {
            return this.sanitizeTableData();
        }
    },
    methods: {
        handleEdit(index) {
            this.pushEditPage(this.getIdFromIndex(index));
        },
        pushEditPage(bibleStudyPlanId) {
            this.$router.push({ name: 'BibleStudyPlanEdit', params: { id: bibleStudyPlanId } });
        },
        handleDropdownCommand(command, index) {
            switch (command) {
            case 'delete':
                this.deletePlan(index);
                break;
            case 'printable': // todo
            case 'pdf': // todo
            case 'mobile': // todo
            default:
                this.$message(`You clicked ${command}`);
                console.log('mounted');
            }
        },
        getIdFromIndex(index) {
            return this.plans[index].id;
        },
        getPlans() {
            this.loading = true;
            this.$store.dispatch(`${this.namespace}/getPlans`).then(() => { this.loading = false; }).catch((error) => {
                this.loading = false;
            });
        },
        addNewBibleStudyPlan({ title, materialId }) {
            BibleStudyPlansRepository.addNewBibleStudyPlan(title, materialId)
                .then((response) => {
                    this.$message('New bible study plan added.');
                    this.pushEditPage(response.data.id);
                })
                .catch((error) => {
                    this.$store.commit('BibleStudyPlans/setError', error);
                });
        },
        deletePlan(index) {
            BibleStudyPlansRepository.deleteBibleStudyPlan(this.getIdFromIndex(index))
                .then((response) => {
                    this.$message('Bible study plan deleted.');
                    this.getPlans(this.$store);
                })
                .catch((error) => {
                    this.$store.commit('BibleStudyPlans/setError', error);
                });
        },
        sanitizeTableData() {
            if (!this.rawPlans) return null;

            const sanitary = this.rawPlans;

            sanitary.forEach((bsp, i) => {
                sanitary[i].created_at = this.$moment(bsp.created_at).format('MM-DD-YYYY');
            });

            return sanitary;
        },
    },
    created() {
        this.getPlans();
        this.$store.dispatch('BibleStudyPlans/getMaterials');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>
